<template>
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-4">
    <div v-if="ruta_actual==='social_worker'">
     <socialWorkFormVue :nombre_ruta="nombre_ruta"></socialWorkFormVue>
    </div>
    <div v-else-if="ruta_actual==='phychologic'">
     <psychologicFormVue :nombre_ruta="nombre_ruta"></psychologicFormVue>
    </div>
    <div v-else-if="ruta_actual==='education'">
     <educationFormVue :nombre_ruta="nombre_ruta"></educationFormVue>
    </div>
    </div>
  </div>
  <loading
      v-model:active="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      :height="100"
      :width="100"
    ></loading>
  </template>
  <script>
  import {
    defineComponent,
    reactive,
    ref,
    onMounted,
    computed,
    watch,
  } from "vue";
  import { useRouter } from "vue-router";
  import Loading from "vue-loading-overlay";
  import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
  import socialWorkFormVue from "./socialworkModule/socialWorkForm.vue";
  import psychologicFormVue from "./psychologicalModule/psychologicForm.vue";
  import educationFormVue from "./educationModule/educationForm.vue";
  // let es = require("./../apexcharts/dist/locales/es.json");
  import es from "./../../../node_modules/apexcharts/dist/locales/es.json"
  export default defineComponent({
    name: "dashboard_modules",
    components: {
        Loading,
        socialWorkFormVue,
        psychologicFormVue,
        educationFormVue
        },
    setup() {
        const router = useRouter();
        const ruta_actual = ref(null);
        const nombre_ruta = ref(null)
        const isLoading = ref(false);
        const navbarContent = ref([]);
        
        onMounted(() => {
            ruta_actual.value = router.currentRoute.value.params.module;
            nombre_ruta.value = router.currentRoute.value.params.module;   
            if(router.currentRoute.value.params.module=='legal'){
                nombre_ruta.value = "Módulo Legal";
            }else if(router.currentRoute.value.params.module=='social_worker'){
                nombre_ruta.value = "Módulo Trabajo Social";
            }else if(router.currentRoute.value.params.module=='phychologic'){
                nombre_ruta.value = "Módulo Psicológico";
            }else if(router.currentRoute.value.params.module=='education'){
                nombre_ruta.value = "Módulo Educación";
            }else if(router.currentRoute.value.params.module=='medical'){
                nombre_ruta.value = "Módulo Salud";
            }else if(router.currentRoute.value.params.module=='dental'){
                nombre_ruta.value = "Módulo Odontológico";
            }
         setCurrentPageBreadcrumbs(`${nombre_ruta.value}`, ["Módulos Interdisciplinarios"]);
      });
      watch(
        () => router.currentRoute.value.params.module,
        (newId, oldId) => {
          // Realiza acciones específicas antes de la actualización de la ruta
          if (newId !== oldId) {
            // Restablece los datos del formulario
            ruta_actual.value = router.currentRoute.value.params.module;
            if(router.currentRoute.value.params.module=='legal'){
                nombre_ruta.value = "Módulo Legal";
            }else if(router.currentRoute.value.params.module=='social_worker'){
                nombre_ruta.value = "Módulo Trabajo Social";
            }else if(router.currentRoute.value.params.module=='phychologic'){
                nombre_ruta.value = "Módulo Psicológico";
            }else if(router.currentRoute.value.params.module=='education'){
                nombre_ruta.value = "Módulo Educación";
                navbarContent.value =[{name_link:'Profesores', content:[]}, 
                                       {name_link:'Inscripciones a Programas Educativos', content:[]}, 
                                       {name_link:'Inscripciones a Programas de Bachillerato', content:[]}, 
                                       {name_link:'Inscripciones a Educación Técnica Alternativa', content:[]},
                                       {name_link:'Inscripciones a Programa de Alfabetización y Postalfabeticación', content:[]}, 
                                       {name_link:'Inscripciones a Educación Superior Universitaria', content:[]},
                                       {name_link:'Inscripciones a Educación No Formal', content:[]}, 
                                       {name_link:'Grado de Estudio de nuevos PPL', content:[]}
                                      ]
                
            }else if(router.currentRoute.value.params.module=='medical'){
                nombre_ruta.value = "Módulo Salud";
            }else if(router.currentRoute.value.params.module=='dental'){
                nombre_ruta.value = "Módulo Odontológico";
            }

             setCurrentPageBreadcrumbs(`${nombre_ruta.value}`, ["Módulos Interdisciplinarios"]);
            // button.value = "Registrar"
            // resetData();
          }
        }
      );
      return {
        isLoading,
        ruta_actual,
        nombre_ruta,
        navbarContent,
      };
    }
  })
  </script>
  <style scoped>
  .basic-drop-shadow {
  box-shadow: 5px 5px 10px;
}
  </style>